import React, { Fragment, useState, useEffect } from "react";
import { connect } from "react-redux";
import { withStyles } from "@material-ui/core/styles";
import Dialog from "@material-ui/core/Dialog";
import DialogTitle from "@material-ui/core/DialogTitle";
import DialogContent from "@material-ui/core/DialogContent";
import DialogActions from "@material-ui/core/DialogActions";
import Button from "@material-ui/core/Button";
import Typography from "@material-ui/core/Typography";
import Table from "@material-ui/core/Table";
import TableBody from "@material-ui/core/TableBody";
import TableCell from "@material-ui/core/TableCell";
import TableHead from "@material-ui/core/TableHead";
import TableRow from "@material-ui/core/TableRow";
import Paper from "@material-ui/core/Paper";
import CircularProgress from "@material-ui/core/CircularProgress";
import TextField from "@material-ui/core/TextField";
import Select from "@material-ui/core/Select";
import MenuItem from "@material-ui/core/MenuItem";
import FormControl from "@material-ui/core/FormControl";
import InputLabel from "@material-ui/core/InputLabel";
import Chip from "@material-ui/core/Chip";
import Grid from "@material-ui/core/Grid";
import cookie from "react-cookies";
import {
  toggleAdminSupportModal,
  setAdminSupportSelectedTicket,
  updateAdminTicketStatus,
  addAdminTicketResponse,
  getAdminTicketDetail,
  getCustomerInfo,
  markTicketAsReadByAdmin,
} from "../../../../redux/modules/admin";

const styles = (theme) => ({
  dialog: {
    minWidth: 800,
  },
  paper: {
    padding: theme.spacing(2),
    marginBottom: theme.spacing(2),
  },
  statusChip: {
    margin: theme.spacing(0.5),
  },
  responseField: {
    marginTop: theme.spacing(2),
    marginBottom: theme.spacing(2),
  },
  ticketHeader: {
    padding: theme.spacing(2),
  },
});

const AdminSupportModal = ({
  classes,
  open,
  tickets,
  loading,
  selectedTicket,
  toggleAdminSupportModal,
  setAdminSupportSelectedTicket,
  updateAdminTicketStatus,
  addAdminTicketResponse,
  getAdminTicketDetail,
  getCustomerInfo,
  markTicketAsReadByAdmin,
}) => {
  const [responseText, setResponseText] = useState("");
  const [selectedStatus, setSelectedStatus] = useState(0);
  const [showDetail, setShowDetail] = useState(false);
  const [searchTerm, setSearchTerm] = useState("");
  const [sortField, setSortField] = useState("");
  const [sortDirection, setSortDirection] = useState("asc");

  const handleClose = () => {
    toggleAdminSupportModal(false);
    setAdminSupportSelectedTicket(null);
    setResponseText("");
    setShowDetail(false);
    setSearchTerm("");
    setSortField("");
    setSortDirection("asc");
  };

  const handleTicketSelect = (ticket) => {
    setAdminSupportSelectedTicket(ticket);
    setSelectedStatus(ticket.status);
    setShowDetail(true);

    if (!ticket.isReadByAdmin) {
      markTicketAsReadByAdmin(ticket.id);
    }
  };

  const handleBackToList = () => {
    setShowDetail(false);
    setAdminSupportSelectedTicket(null);
    setResponseText("");
  };

  const handleStatusUpdate = () => {
    if (selectedTicket) {
      updateAdminTicketStatus(selectedTicket.id, selectedStatus);
    }
  };

  const handleResponseSubmit = () => {
    if (selectedTicket && responseText.trim()) {
      const adminUserId = cookie.load("UserId");
      addAdminTicketResponse(selectedTicket.id, responseText, adminUserId);
      setResponseText("");
    }
  };

  const getResponderName = (response) => {
    const currentAdminId = cookie.load("UserId");
    const adminName = cookie.load("AdminName") || "Admin";

    if (!response.isCustomer) {
      // Admin response
      if (response.responderId === currentAdminId) {
        return adminName ? `🛠️ Admin (${adminName})` : "🛠️ Admin";
      } else {
        return "🛠️ Admin";
      }
    } else {
      // Customer response
      if (selectedTicket && selectedTicket.customerName) {
        return `👤 ${selectedTicket.customerName}`;
      } else {
        return "👤 Müşteri";
      }
    }
  };

  const getStatusText = (status) => {
    switch (status) {
      case 1:
        return "Açık";
      case 2:
        return "Kapalı";
      case 3:
        return "İşlemde";
      default:
        return "Bilinmiyor";
    }
  };

  const getStatusColor = (status) => {
    switch (status) {
      case 1:
        return "#ff9800";
      case 2:
        return "#4caf50";
      case 3:
        return "#2196f3";
      default:
        return "#9e9e9e";
    }
  };

  const getPlatformText = (platform) => {
    switch (platform) {
      case 1:
        return "javikurye";
      case 2:
        return "javipos";
      default:
        return "Bilinmiyor";
    }
  };

  const getPlatformColor = (platform) => {
    switch (platform) {
      case 1:
        return "#e91e63";
      case 2:
        return "#3f51b5";
      default:
        return "#9e9e9e";
    }
  };

  const formatDate = (dateString) => {
    if (!dateString) return "-";
    const date = new Date(dateString);
    return (
      date.toLocaleDateString("tr-TR") + " " + date.toLocaleTimeString("tr-TR")
    );
  };

  const handleSort = (field) => {
    if (sortField === field) {
      setSortDirection(sortDirection === "asc" ? "desc" : "asc");
    } else {
      setSortField(field);
      setSortDirection("asc");
    }
  };

  const filteredAndSortedTickets = () => {
    let filtered = tickets.filter((ticket) => {
      const searchLower = searchTerm.toLowerCase();
      return (
        ticket.subject.toLowerCase().includes(searchLower) ||
        ticket.ticketNumber.toLowerCase().includes(searchLower)
      );
    });

    if (sortField) {
      filtered.sort((a, b) => {
        let aValue, bValue;

        if (sortField === "status") {
          aValue = a.status;
          bValue = b.status;
        } else if (sortField === "date") {
          aValue = new Date(a.createdAt);
          bValue = new Date(b.createdAt);
        }

        if (sortDirection === "asc") {
          return aValue > bValue ? 1 : -1;
        } else {
          return aValue < bValue ? 1 : -1;
        }
      });
    }

    return filtered;
  };

  return (
    <Dialog
      open={open}
      onClose={handleClose}
      maxWidth="lg"
      fullWidth
      className={classes.dialog}
    >
      <DialogTitle>
        <Typography variant="h6">
          {showDetail
            ? `Talep Detayı - ${selectedTicket?.ticketNumber || ""}`
            : "Destek Talepleri Yönetimi"}
        </Typography>
      </DialogTitle>
      <DialogContent dividers>
        {loading ? (
          <div style={{ textAlign: "center", padding: 20 }}>
            <CircularProgress />
          </div>
        ) : !showDetail ? (
          // Tickets List View
          <Paper className={classes.paper}>
            <div
              style={{
                display: "flex",
                justifyContent: "space-between",
                alignItems: "center",
                marginBottom: 16,
              }}
            >
              <Typography variant="h6">
                Tüm Destek Talepleri ({filteredAndSortedTickets().length})
              </Typography>

              <TextField
                label="Arama (Konu ve Talep No)"
                value={searchTerm}
                onChange={(e) => setSearchTerm(e.target.value)}
                variant="outlined"
                size="small"
                style={{ width: 300 }}
                placeholder="Konu adı veya talep numarası ile ara..."
              />
            </div>

            <Table size="small">
              <TableHead>
                <TableRow>
                  <TableCell>Platform</TableCell>
                  <TableCell>Talep No</TableCell>
                  <TableCell>Konu</TableCell>
                  <TableCell>Firma Adı</TableCell>
                  <TableCell
                    style={{ cursor: "pointer", userSelect: "none" }}
                    onClick={() => handleSort("status")}
                  >
                    <div style={{ display: "flex", alignItems: "center" }}>
                      <span
                        style={{
                          color:
                            sortField === "status" && sortDirection === "desc"
                              ? "#1976d2"
                              : "#ccc",
                          marginRight: 4,
                          fontSize: 10,
                        }}
                      >
                        ▼
                      </span>
                      Durum
                      <span
                        style={{
                          color:
                            sortField === "status" && sortDirection === "asc"
                              ? "#1976d2"
                              : "#ccc",
                          marginLeft: 4,
                          fontSize: 10,
                        }}
                      >
                        ▲
                      </span>
                    </div>
                  </TableCell>
                  <TableCell
                    style={{ cursor: "pointer", userSelect: "none" }}
                    onClick={() => handleSort("date")}
                  >
                    <div style={{ display: "flex", alignItems: "center" }}>
                      <span
                        style={{
                          color:
                            sortField === "date" && sortDirection === "desc"
                              ? "#1976d2"
                              : "#ccc",
                          marginRight: 4,
                          fontSize: 10,
                        }}
                      >
                        ▼
                      </span>
                      Tarih
                      <span
                        style={{
                          color:
                            sortField === "date" && sortDirection === "asc"
                              ? "#1976d2"
                              : "#ccc",
                          marginLeft: 4,
                          fontSize: 10,
                        }}
                      >
                        ▲
                      </span>
                    </div>
                  </TableCell>
                  <TableCell>İşlemler</TableCell>
                </TableRow>
              </TableHead>
              <TableBody>
                {filteredAndSortedTickets().map((ticket) => (
                  <TableRow key={ticket.id}>
                    <TableCell>
                      <Chip
                        label={getPlatformText(ticket.platform)}
                        style={{
                          backgroundColor: getPlatformColor(ticket.platform),
                          color: "white",
                          borderRadius: 16,
                        }}
                        size="small"
                      />
                    </TableCell>
                    <TableCell>{ticket.ticketNumber}</TableCell>
                    <TableCell>{ticket.subject}</TableCell>
                    <TableCell>{ticket.brandName || "Bilinmiyor"}</TableCell>
                    <TableCell>
                      <Chip
                        label={getStatusText(ticket.status)}
                        style={{
                          backgroundColor: getStatusColor(ticket.status),
                          color: "white",
                        }}
                        size="small"
                      />
                    </TableCell>
                    <TableCell>{formatDate(ticket.createdAt)}</TableCell>
                    <TableCell>
                      <Button
                        size="small"
                        variant="outlined"
                        onClick={() => handleTicketSelect(ticket)}
                      >
                        Detay
                      </Button>
                    </TableCell>
                  </TableRow>
                ))}
              </TableBody>
            </Table>
          </Paper>
        ) : (
          // Ticket Detail View
          selectedTicket && (
            <div>
              {/* Back Button */}
              <div style={{ marginBottom: 16 }}>
                <Button
                  variant="outlined"
                  onClick={handleBackToList}
                  startIcon={<span>←</span>}
                  style={{ marginBottom: 10 }}
                >
                  Destek Talepleri Listesi
                </Button>
              </div>

              <Paper className={classes.paper}>
                <div className={classes.ticketHeader}>
                  <Typography variant="h6">
                    Talep Detayı - {selectedTicket.ticketNumber}
                  </Typography>
                  <Chip
                    label={getStatusText(selectedTicket.status)}
                    style={{
                      backgroundColor: getStatusColor(selectedTicket.status),
                      color: "white",
                      marginTop: 8,
                    }}
                    size="small"
                  />
                </div>

                <div style={{ padding: 16 }}>
                  <Typography variant="subtitle2" gutterBottom>
                    <strong>Konu:</strong> {selectedTicket.subject}
                  </Typography>
                  <Typography variant="body2" gutterBottom>
                    <strong>Açıklama:</strong> {selectedTicket.description}
                  </Typography>
                  <Typography variant="body2" gutterBottom>
                    <strong>Firma Adı:</strong>{" "}
                    {selectedTicket.brandName || "Bilinmiyor"}
                  </Typography>
                  <Typography
                    variant="body2"
                    gutterBottom
                    style={{
                      display: "flex",
                      alignItems: "center",
                      gap: "8px",
                    }}
                  >
                    <strong>Platform:</strong>
                    <Chip
                      label={getPlatformText(selectedTicket.platform)}
                      style={{
                        backgroundColor: getPlatformColor(
                          selectedTicket.platform
                        ),
                        color: "white",
                        borderRadius: 16,
                        height: 20,
                        fontSize: 11,
                      }}
                      size="small"
                    />
                  </Typography>
                  <Typography variant="body2" gutterBottom>
                    <strong>Müşteri:</strong>{" "}
                    {selectedTicket.customerName || "Bilinmiyor"}
                  </Typography>
                  <Typography variant="body2" gutterBottom>
                    <strong>Oluşturulma Tarihi:</strong>{" "}
                    {formatDate(selectedTicket.createdAt)}
                  </Typography>

                  {/* Status Update */}
                  <FormControl fullWidth className={classes.responseField}>
                    <InputLabel>Talep Durumu</InputLabel>
                    <Select
                      value={selectedStatus}
                      onChange={(e) => setSelectedStatus(e.target.value)}
                    >
                      <MenuItem value={1}>Açık</MenuItem>
                      <MenuItem value={2}>Kapalı</MenuItem>
                      <MenuItem value={3}>İşlemde</MenuItem>
                    </Select>
                  </FormControl>

                  <Button
                    variant="contained"
                    color="primary"
                    onClick={handleStatusUpdate}
                    disabled={selectedStatus === selectedTicket.status}
                    style={{ marginBottom: 16 }}
                  >
                    Durumu Güncelle
                  </Button>

                  {/* Responses */}
                  {selectedTicket.responses &&
                    selectedTicket.responses.length > 0 && (
                      <div style={{ marginBottom: 16 }}>
                        <Typography variant="subtitle2" gutterBottom>
                          <strong>
                            Cevaplar ({selectedTicket.responses.length})
                          </strong>
                        </Typography>
                        <div
                          style={{
                            maxHeight: 200,
                            overflow: "auto",
                            border: "1px solid #e0e0e0",
                            borderRadius: 4,
                            padding: 8,
                          }}
                        >
                          {selectedTicket.responses.map((response, index) => (
                            <Paper
                              key={index}
                              style={{
                                padding: 12,
                                marginBottom: 8,
                                borderLeft: `4px solid ${
                                  response.isCustomer ? "#ff9800" : "#4caf50"
                                }`,
                              }}
                            >
                              <div
                                style={{
                                  display: "flex",
                                  justifyContent: "space-between",
                                  alignItems: "center",
                                  marginBottom: 8,
                                }}
                              >
                                <Chip
                                  label={getResponderName(response)}
                                  size="small"
                                  style={{
                                    backgroundColor: response.isCustomer
                                      ? "#ff9800"
                                      : "#4caf50",
                                    color: "white",
                                    fontSize: 11,
                                  }}
                                />
                                <Typography
                                  variant="caption"
                                  color="textSecondary"
                                >
                                  {formatDate(response.createdAt)}
                                </Typography>
                              </div>
                              <Typography variant="body2" gutterBottom>
                                {response.message}
                              </Typography>
                            </Paper>
                          ))}
                        </div>
                      </div>
                    )}

                  {/* Add Response */}
                  <TextField
                    label="Yeni Cevap"
                    multiline
                    rows={4}
                    fullWidth
                    value={responseText}
                    onChange={(e) => setResponseText(e.target.value)}
                    className={classes.responseField}
                    placeholder="Müşteriye cevabınızı yazın..."
                  />

                  <Button
                    variant="contained"
                    color="secondary"
                    onClick={handleResponseSubmit}
                    disabled={!responseText.trim()}
                  >
                    Cevap Gönder
                  </Button>
                </div>
              </Paper>
            </div>
          )
        )}
      </DialogContent>
      <DialogActions>
        <Button onClick={handleClose} color="primary">
          Kapat
        </Button>
      </DialogActions>
    </Dialog>
  );
};

const mapStateToProps = (state) => ({
  open: state.get("adminReducer").adminSupportModalVisible,
  tickets: state.get("adminReducer").adminSupportTickets,
  loading: state.get("adminReducer").adminSupportLoading,
  selectedTicket: state.get("adminReducer").adminSupportSelectedTicket,
});

const mapDispatchToProps = {
  toggleAdminSupportModal,
  setAdminSupportSelectedTicket,
  updateAdminTicketStatus,
  addAdminTicketResponse,
  getAdminTicketDetail,
  getCustomerInfo,
  markTicketAsReadByAdmin,
};

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(withStyles(styles)(AdminSupportModal));
